import { useEffect } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ILocationState } from '../../commons/interfaces/auth.interface';
import Paper from '../../components/Paper';
import useAuth from '../../hooks/auth.hook';
import './style.scss';

const AuthLayout = () => {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const from = (location.state as ILocationState)?.from?.pathname || '/';
    if (auth.isLoggedIn()) {
      navigate(from, { replace: true });
    }
  }, [auth, navigate, location.state]);

  return (
    <Container className="vh-100 d-flex align-items-center">
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={11} md={8} lg={7} xl={6} xxl={5}>
          <Paper>
            <div className="container-loader">
              {auth.loading ? (
                <div className="loader">
                  <Spinner animation="border" />
                </div>
              ) : null}
              <Outlet />
            </div>
          </Paper>
        </Col>
      </Row>
    </Container>
  );
};

export default AuthLayout;
